import React, {useMemo} from "react";
import GiftCard from "../../component/GiftCard";
import {Grid, Header, Layout} from "./styles";
import {GiftType} from "../../typing";




export interface GiftGridProps {
    data: GiftType[];
    onClick: (item: GiftType, index: number) => void;
}
function GiftGrid(props: GiftGridProps) {
    const {
        data,
        onClick,
    } = props;

    // const specs = useMemo(() => {
    //     return [6, 20, 98, 100, 300, 328, 600, 648, 1000, 2000, 50000]
    // }, [])
    return <Layout className={"gift-grid"}>
        <Grid>
            {data.map((item, index) => {
                return <GiftCard key={item.level} amount={item.level} onClick={() => {
                    onClick?.(item, index);
                }} />
            })}
        </Grid>
    </Layout>
}

export default GiftGrid;